/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */

import { html, PolymerElement } from '../../@polymer/polymer/polymer-element.js';
import { mixinBehaviors } from "../../@polymer/polymer/lib/legacy/class.js";
class chatbotWindow extends mixinBehaviors([accessibilityBehaviours.commonFunctions], PolymerElement) {

    static get properties() {
        return {
            botActive: {
                type: Boolean,
                value: false,
                notify: true,
            }
        }
    }

    static get template() {
        return html `
        <style include="corp-app-styles">
            .chatBotIFrame{
                z-index: 10;
                bottom: 0px;
                right: 0 !important;
                width: 375px !important;
                height:500px !important;
                position: fixed;
                border: none;
            }
            :dir(rtl) .chatBotIFrame{
                z-index: 10;
                bottom: 0px;
                left: 0 !important;
                width: 375px !important;
                height:500px !important;
                position: fixed;
                border: none;
            }			
            .chatfab, .chatfab:focus{
                width: 25px !important;
                background: var(--brand-color);
                position: relative;
                color: var(--primary-light-color);
                padding: 8px;
            }
            .chatbuttonExpanded{
                color: var(--primary-light-color);
                cursor: pointer;
                background-color: var(--brand-color);
                border-bottom-left-radius: 3px;
                border-top-left-radius: 3px;
                top: 6px;
                position: relative;
                margin: auto;
                padding: 12px;
            }
            .chatIconPosition{
                position: fixed;
                right: 0%;
                bottom: 13%;
            }			
            :dir(rtl) .chatIconPosition{
                position: fixed;
                left: 0%;
                bottom: 13%;
            }
            .chatLogo{
                display: none;
            }			
            .chatIconPosition:hover .chatLogo{
                display: block;
            }			
            .float-left{
                float: left;
            }
            :dir(rtl) .float-left{
                float: right;
            }
            .overlay {
                height:100%;
                width:100%;
                position:fixed;
                z-index:10;
                top:0;
                left:0;
                background : rgba(0,0,0,0.6);
            }            
        </style>

        <!-- chat icon apperance before hover -->
        <template id="activeChatContainer" is="dom-if" if={{!botActive}} restamp="true">
            <div class="chatIconPosition">
                <div id="yourBankAssitance" role="button" class="outlineOffset chatLogo chatbuttonExpanded float-left font-size-m elevation-2" on-tap="_botActive" tabindex="0">
                    <oe-i18n-msg msgid="l_yourBankAssistance"></oe-i18n-msg>
                </div>
                <div id="chatIconLabel" role="button" class="outlineOffset cursor-pointer chatfab elevation-2 float-left font-size-xs" on-tap="_botActive" tabindex="0">
                    <iron-icon icon="chatBotIcon"></iron-icon>
                    <oe-i18n-msg msgid="l_chat"></oe-i18n-msg>
                </span>
            </div>
        </template>

        <!-- chatbot loaded via iframe -->
        <div hidden={{!botActive}}>
            <div id="activeChatBot" class="overlay">
                <iframe id="chatbotiframe" title="chatbot" on-load="loaded" class="chatBotIFrame" allow="microphone;" src="{{activeAiIFrameUrl}}" ></iframe>
            </div>
        </div>
        `;
    }

    //flag for chatbot toggle
    _botActive() {
        if (document.getElementsByTagName("chatbot-window")[0].$.chatbotiframe.contentWindow.length > 0) {
            this.botActive = true;
        }
        else {
            this.fire('oe-show-error', getLabel('m_chatbotError'));
        }
    }

    //on-load function to add event listener for chatbot actions
    loaded() {
        window.addEventListener('message', this.recieveMessage.bind(this), false);
    }

    ready() {
        super.ready();
        this.activeAiUrl = config.SpeedBoat.App.ActiveChatbot.activeAiUrl;
        this.activeAiIFrameUrl = this.activeAiUrl + config.SpeedBoat.App.ActiveChatbot.activeAiIFrameUrl;
    }

    connectedCallback() {
        super.connectedCallback();
        this.corpId = clientStorage.get(storageType.session, 'corpId')
        this.userId = clientStorage.get(storageType.session, 'uniqueUserId');
        this.bankId = clientStorage.get(storageType.session, 'tenantId');
        this.loopbackToken = clientStorage.get(storageType.session, 'auth_token');
        this.langId = clientStorage.get(storageType.session, 'lang');
        this.activeAiIFrameUrl += "&tenant=" + this.bankId + "&corpId=" + this.corpId + "&userId=" + this.userId + "&lb=" + this.loopbackToken + "&lang=" + this.langId;
    }

    //event listener function to capture the event origin and toggle the response action
    recieveMessage(event) {
        console.log(event);
        if (event.origin === this.activeAiUrl) {
            if (event.data) {
                switch (event.data.type) {
                    case "hideChatBox":
                        {
                            this.botActive = false;
                            break;
                        }
                    case "destroyContainerFrame":
                        {
                            this.botActive = false;
                            break;
                        }
                    case "showChatBox":
                        {
                            // this.botActive = true;
                            break;
                        }
                    case "setToken":
                        {
                            //this case refreshes the loopbackToken in the application when the chatbot is used for long time.
                            sessionStorage.auth_token = event.data.data;
                            sessionStorage.tokenGeneratedTime = getNewDate().getTime();
                            break;
                        }
                }
            }
        }
    }
}

window.customElements.define('chatbot-window', chatbotWindow);
